module.exports = __webpack_public_path__ + "media/images/business/i-trial-0718d870e50a3061abb9dd46a79e2be0.svg";